import React, { Component } from "react";
import Card from "../../shared/Card";

class OwnerBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false
    };
  }

  toTitleCase(str) {
    if (str.indexOf("PO BOX") >= 0) {
      return str;
    }
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  formatPhone(phoneNo) {
    let s2 = ("" + phoneNo).replace(/\D/g, "");
    var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
    return !m ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
  }

  render() {
    const owner = (
      <Card
        cardType="default"
        cardHeader="Owner"
        headerColor="#046B99"
        headerTextColor="white"
        cardBody={
          <div className="owner-card">
            <div className="banner-title pl-0">{this.props.OWNER_NAME}</div>
            <div className="">{this.props.OWNER_ST1}</div>
            <div className="">{this.props.OWNER_CITY},  {this.props.OWNER_STATE} {this.props.OWNER_ZIP}</div>
            <div className="">{this.formatPhone(this.props.OWNER_PHONE)}</div>
            {this.props.isRegulator && <div style={{ display: "inline-grid" }}></div>}
          </div>
        }
        cardColor="white"
      />
    );

    return <div>{owner}</div>;
  }
}

export default OwnerBanner;
